module.exports = __webpack_public_path__ + "static/base-picture-1551cc5fa36f0d803f9ade3e9ad3e004.png";